<script setup>

import {useGetValidatedFields} from "@/composables/common/useGetValidatedFields";
import {useClearCompany} from "@/composables/bookings/useClearCompany";
import {useClearShipperContact} from "@/composables/bookings/useClearShipperContact";
import {useMapShipperAddress} from "@/composables/bookings/useMapShipperAddress";

import MultiSearchDropDown from "@/components/common/input/MultiSearchDropDown.vue";
import StaticTooltip from "@/components/common/other/StaticTooltip.vue";
import API from "@/classes/global/API";
import {computed, onMounted} from "vue";

const emits = defineEmits(['update:modelValue', 'addNewShipperAddress', 'editShipperAddress'])

const props = defineProps({

  modelValue: {},
  validationViewModel: {}

})

const updateShippers = computed(() => {

  if (props.modelValue.shipper.shipperName || props.modelValue.metaData.shippers) {
    return Math.random().toString(36).substring(2, 15);
  }
})

async function getCompanyDetails(name, section) {

  props.modelValue[section].id = parseInt(name.id);

  useClearCompany('shipper', props, props.validationViewModel);

  let response = await API.getCompanyDetail(name.id)

  if (response) {

    try {

      mapShipperAddress(response);

    } catch (error) {

      // TODO Log Error

    }

  }

}

function handleClearCompany(area) {

  useClearCompany(area, props, props.validationViewModel);

}

function mapShipperAddress(data) {

  useClearShipperContact(props.modelValue);
  useMapShipperAddress(data, props.modelValue);

}

</script>

<template>
  <div class="global-address-select">

    <div class="cmp-multi-booking_address-layout">
      <MultiSearchDropDown
          :key="updateShippers"
          :requiredField="useGetValidatedFields (props.modelValue.metaData.validatedFields, 'shipperName' )"
          :allowCustomValue="false"
          :useServerSearch="true"
          :maxLength="70"
          searchType="shipper"
          @select="getCompanyDetails($event, 'shipper')"
          @clear="handleClearCompany('shipper')"
          @update:validation-fail="validationViewModel = $event"
          label="Shipper"
          :label-top="true"
          :label-width="50"
          v-model="props.modelValue.shipper.shipperName"
          :selectPrimitiveValue="true"
          :data-source="props.modelValue.metaData.shippers">
      </MultiSearchDropDown>
      <StaticTooltip :icon="false">
        <template #content>
          <div style="width: 300px;">
            Select a Shipper by typing a Company name or postcode to perform a search. Click here to add
            a new address record, or use a one time address for the booking.
          </div>
        </template>
        <img class="global-icon-button"
             @click="emits('addNewShipperAddress')"
             height="22"
             width="22"
             src="@/assets/icons/akar/akar-icons--circle-plus.png">
      </StaticTooltip>
      <StaticTooltip :icon="false">
        <template #content>
          <div style="width: 300px;">
            Edit the Shipper address, you may also create a new Shipper for your records if you have chosen
            to use un saved address information previously.
          </div>
        </template>
        <img class="global-icon-button"
             @click="emits('editShipperAddress')"
             v-if="modelValue.shipper.shipperName"
             height="22" width="22"
             src="@/assets/icons/akar/akar-icons--edit.png">
      </StaticTooltip>
    </div>
    <div class="cmp-multi-booking_address-container">
      <div v-if="modelValue.shipper.id === 0 && modelValue.shipper.shipperName"
           style="position: absolute; top: 12px; right: 5px">
        <img title="This address is not saved in your system."
             height="16"
             width="16"
             src="@/assets/icons/unsaved.png">
      </div>
      <div class="cmp-multi-booking_selected-address">
        <div v-if="props.modelValue.shipper.shipperName">
          <div>{{ props.modelValue.shipper.shipperAddressLine1 }}</div>
          <div>{{ props.modelValue.shipper.shipperAddressLine2 }}</div>
          <div>{{ props.modelValue.shipper.shipperCity }}</div>
          <div>{{ props.modelValue.shipper.shipperPostcode }}</div>
          <div>{{ props.modelValue.shipper.shipperCounty }}</div>
          <div>{{ props.modelValue.shipper.shipperCountry }}</div>
          <div v-if="props.modelValue.shipper.shipperVatNumber" class="cmp-multi-booking_address-heading">Vat Number</div>
          <div>{{ props.modelValue.shipper.shipperVatNumber }}</div>
        </div>
        <div v-if="!props.modelValue.shipper.shipperName" class="cmp-multi-booking_address-placeholder-wrapper">
          <div style="display:flex; align-items: center">
            <img height="26" width="26" src="@/assets/icons/address-marker.png">
            <span>Address Information</span>
          </div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p1"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p2"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p3"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

@import '@/css/booking/multi-booking.scss';

</style>